import apiClient from "@/services/ApiClient";

export function getListActions(path) {
  const getListItems = payload => apiClient.post(`${path}/items`, payload);
  const getListHeaders = () => apiClient.get(`${path}/headers`);

  return { getListItems, getListHeaders };
}
